export type JobStatus = 'UPLOADING' | 'TRANSCRIBING' | 'ANALYZING' | 'COMPLETED' | 'FAILED';

export const ARTIFACTS = ['transcript', 'summary', 'todos', 'todos-json', 'bundle'] as const;
export type ArtifactName = (typeof ARTIFACTS)[number];

export interface Job {
  jobId: string;
  fileName: string;
  status: JobStatus;
  createdAt: string;
  updatedAt: string;
  title?: string;
  todoCount?: number;
  durationSeconds?: number;
  speakerCount?: number;
  wordCount?: number;
  markerCount?: number;
  artifacts?: Partial<Record<ArtifactName, string>>;
  error?: string;
}

export const STATUS_LABEL: Record<JobStatus, string> = {
  UPLOADING: 'Wird hochgeladen',
  TRANSCRIBING: 'Wird transkribiert',
  ANALYZING: 'Wird ausgewertet',
  COMPLETED: 'Fertig',
  FAILED: 'Fehlgeschlagen',
};

export const IN_PROGRESS: JobStatus[] = ['UPLOADING', 'TRANSCRIBING', 'ANALYZING'];
